import CablesConstants from "../shared_constants.json" with { type: "json" };

export default {
    ...CablesConstants
};
